import TopEngagedTeachers from './TopEngagedTeachers';
import StudentWatchList from './StudentWatchList';
import styles from './SchoolReport.module.scss';
import { SchoolReportState } from './SchoolReport';

const SchoolDashboard = ({
  legacyPlatformEvents,
  legacyPlatformEventsReady,
  journalsMap,
  journalsMapReady,
  legacyPeekavilleEvents,
  legacyPeekavilleEventsReady,
  selectedSchoolYear,
  teacherStudentMap,
  teacherStudentMapReady,
  teacherClassroomMaps,
  teacherClassroomMapsReady,
  userListReady,
  userList,
  newMixpanelEvents,
  newMixpanelEventsReady,
}: SchoolReportState) => {
  return (
    <div className={styles.schoolDashboard}>
      <div className={styles.gutterContainer}>
        <TopEngagedTeachers
          teacherClassroomMaps={teacherClassroomMaps}
          teacherClassroomMapsReady={teacherClassroomMapsReady}
          selectedSchoolYear={selectedSchoolYear}
          legacyPlatformEvents={legacyPlatformEvents}
          legacyPlatformEventsReady={legacyPlatformEventsReady}
          legacyPeekavilleEvents={legacyPeekavilleEvents}
          legacyPeekavilleEventsReady={legacyPeekavilleEventsReady}
          newMixpanelEvents={newMixpanelEvents}
          newMixpanelEventsReady={newMixpanelEventsReady}
          userListReady={userListReady}
          userList={userList.list}
        />
        <StudentWatchList
          journalsMap={journalsMap}
          journalsMapReady={journalsMapReady}
          selectedSchoolYear={selectedSchoolYear}
          teacherStudentMap={teacherStudentMap}
          teacherStudentMapReady={teacherStudentMapReady}
          userListReady={userListReady}
          userList={userList.list}
        />
      </div>
    </div>
  );
};

export default SchoolDashboard;
